import {
  Color,
  ComboboxSingleSelect,
  Icons
} from '@eggplant/pattern-library'
import { TestManagementToolOptions } from './constants'
import type { DropdownPlacement } from '@eggplant/types'

interface Props {
  dropdownPlacement?: DropdownPlacement
  initialOptions?: {
    label: string
    value: string
  }[]
  isFilter?: boolean
  isFilterFixedMinMaxWidth?: boolean
  isHighlighted?: boolean
  isRequired?: boolean
  onChange: (value: string) => void
  onClear?: () => void
  placeholder?: string
  value: string
  isDisabled?: boolean
  hasIcon?: boolean
  customTooltip?: string
}

const SelectTestManagementTool = ({
  dropdownPlacement = 'bottom',
  initialOptions = [],
  isFilter = false,
  isFilterFixedMinMaxWidth = false,
  isHighlighted = false,
  isRequired = false,
  onChange,
  onClear,
  placeholder = 'Select test management tool',
  value,
  isDisabled = false,
  hasIcon = false,
  customTooltip
// eslint-disable-next-line complexity
}: Props) => {
  const currentOption = TestManagementToolOptions.find(item => item.value === value)

  const buttonText = currentOption?.value
    ? currentOption.label
    : placeholder

  const customPrompt = !value && !isFilter
    ? (
      <Color variant='theme-description-text'>
        {buttonText}
      </Color>
    )
    : buttonText

  const renderIcon = () => hasIcon
    ? Icons.TestTools
    : undefined

  const isDropdownHighlighted = isHighlighted && !!value

  return (
    <ComboboxSingleSelect
      Icon={renderIcon()}
      ariaLabel='test-management-tool-select'
      customPrompt={customPrompt}
      customTooltip={customTooltip}
      dropdownPlacement={dropdownPlacement}
      initialOptions={initialOptions}
      isDisabled={isDisabled}
      isFilter={isFilter}
      isFilterFixedMinMaxWidth={isFilterFixedMinMaxWidth}
      isHighlighted={isDropdownHighlighted}
      isRequired={isRequired}
      key={value}
      onChange={onChange}
      onClear={onClear}
      options={TestManagementToolOptions}
      prompt={buttonText}
      value={value}
    />
  )
}

export default SelectTestManagementTool
